import React from 'react'
import EventList from './eventList'

const EventListPage = () => (
    <>
        <div className='commonTopPadding'>
            <EventList heading='All Events' showFilters paginated />
        </div>
    </>
)

export default EventListPage
